<template>
  <div
    ref="base_report_board"
    class="h-100 w-100"
  >
    <div
      class="main-container-report h-100 w-100 p-0 m-0"
      :class="{ disabled: isLoadingGraphsReportViewer }"
      @mouseover="onHover('ReportViewer/reportBoard')"
      @mouseleave="onLeave"
    >
      <grid-layout
        ref="board_grid"
        :layout="cardsLayout"
        class="largeCard"
        :col-width="COLWIDTH_GRID"
        :row-height="ROW_HEIGHT_GRID"
        :col-num="12"
        :is-draggable="isEditModeReportViewer && !isPlotlyHovered"
        :is-resizable="isEditModeReportViewer"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[MARGIN_GRID, MARGIN_GRID]"
        :use-css-transforms="true"
        @layout-updated="layoutLargeUpdatedEvent"
      >
        <grid-item
          v-for="item in cardsLayout"
          :key="item.i"
          :ref="item.i"
          class="grid-item-largeCard"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
        >
          <b-dropdown
            v-if="isEditModeReportViewer"
            size="sm"
            variant="link"
            class="more-options-card py-0"
            toggle-class="text-decoration-none"
            no-caret
            :lazy="true"
          >
            <template #button-content>
              <span class="btn-more-options p-0 m-0">˙˙˙</span>
            </template>
            <b-dropdown-item @click="hideCard(item)">
              Hide
            </b-dropdown-item>
          </b-dropdown>
          <div
            :id="item.i.replace(' ', '') + '_div'"
            :ref="item.i + '_div'"
            class="m-0 p-0"
          >
            <grid-layout
              :ref="item.i + '_layout'"
              :layout="item.inner"
              :col-width="COLWIDTH_GRID"
              :row-height="ROW_HEIGHT_GRID"
              :col-num="NUM_COLS_GRID"
              :is-draggable="isEditModeReportViewer && !isPlotlyHovered"
              :is-resizable="isEditModeReportViewer"
              :is-mirrored="false"
              :vertical-compact="true"
              :margin="[MARGIN_GRID, MARGIN_GRID]"
              :use-css-transforms="true"
              @layout-updated="layoutUpdatedEvent"
            >
              <div>
                <div class="plotly-title-container">
                  <p class="plotly-title">
                    {{ item.legend }}
                  </p>
                </div>
                <grid-item
                  v-for="itemInner in item.inner"
                  :key="itemInner.i"
                  class="grid-item-smallCard"
                  :x="itemInner.x"
                  :y="itemInner.y"
                  :w="itemInner.w"
                  :h="itemInner.h"
                  :i="itemInner.i"
                >
                  <b-dropdown
                    v-if="isEditModeReportViewer"
                    size="sm"
                    variant="link"
                    class="more-options-card py-0"
                    :class="{'more-options-card-plotly': itemInner.type === TYPE_PLOTLY}"
                    dropdown
                    toggle-class="text-decoration-none"
                    no-caret
                    :lazy="true"
                  >
                    <template #button-content>
                      <span class="btn-more-options p-0 m-0">˙˙˙</span>
                    </template>
                    <b-dropdown-item @click="hideCard(itemInner)">
                      Hide
                    </b-dropdown-item>
                  </b-dropdown>
                  <div
                    :ref="'div_' + itemInner.i"
                    class="m-0 p-0"
                    :class="{
                      'h-100 w-100': itemInner.type == TYPE_IMAGE || !itemInner.success,
                      'table-div':itemInner.type === TYPE_TABLE,
                    }"
                  >
                    <div
                      v-if="itemInner.success && itemInner.type === TYPE_IMAGE"
                      class="file-name-div w-100"
                    >
                      <p class="file-name m-0 p-0">
                        {{ itemInner.legend }}
                      </p>
                    </div>
                    <Plotly
                      v-if="itemInner.success && itemInner.type === TYPE_PLOTLY"
                      :ref="itemInner.i"
                      :data="itemInner.data"
                      :layout="itemInner.layout"
                      :propsid="`plotly-${itemInner.i.replace(' ', '')}`"
                      @hover="isPlotlyHovered = true"
                      @unhover="isPlotlyHovered = false"
                    />
                    <b-table
                      v-else-if="itemInner.success && itemInner.type === TYPE_TABLE"
                      :ref="itemInner.i"
                      striped
                      responsive
                      hover
                      small
                      class="table-card h-100 m-0"
                      :items="itemInner.items"
                      :fields="itemInner.fields"
                      :sort-compare="customSorting"
                    >
                      <template #head()="data">
                        {{ data.column }}
                      </template>
                      <template #cell(Check)="data">
                        <b :class="[data.item.Check.toUpperCase() ==='FAIL'? 'text-red-600': 'text-green-600',]">
                          {{ data.item.Check }}
                        </b>
                      </template>
                    </b-table>

                    <img
                      v-else-if=" itemInner.success &&itemInner.type === TYPE_IMAGE"
                      :ref="itemInner.i"
                      :src="itemInner.data"
                      class="picture-card w-100"
                    >
                    <div
                      v-else
                      class="h-100 w-100 text-center error-div"
                    >
                      <img
                        class="errorRendering"
                        src="@/assets/reportBoard/plotNotFound.png"
                        alt="Error in the card"
                      >
                      <p class="error-text-card">
                        {{ itemInner.legend }}
                      </p>
                    </div>
                  </div>
                </grid-item>
              </div>
            </grid-layout>
          </div>
        </grid-item>
      </grid-layout>
    </div>
    <div
      v-if="isLoadingGraphsReportViewer"
      class="loading"
    >
      <div class="loading-elements">
        <radial-progress-bar
          ref="loadingAnimation"
          :key="loadingKey"
          :diameter="200"
          :completed-steps="completedSteps"
          :total-steps="totalSteps"
        >
          <p>Loading...</p>
          <p>({{ completedSteps }} of {{ totalSteps }})</p>
        </radial-progress-bar>
      </div>
    </div>
  </div>
</template>

<script>
import VueGridLayout from 'vue-grid-layout';
import { mapGetters, mapActions } from 'vuex';
import Plotly from '@/components/common/Plotly'
import RadialProgressBar from 'vue-radial-progress';
import ReportInfo from '@/functions/ReportInfo.js';
import { DATA_TYPE_PICTURE, DATA_TYPE_PLOTLY } from '@/common/sharedDefinitions/dataExtractors/baseExtractor.js';
import { TYPE_PLOTLY } from '@/common/sharedDefinitions/dataExtractors/baseExtractor.js';
import defaultLayoutGraphs from '@/common/defaultLayoutGraphs';
import domtoimage from 'dom-to-image';

// It could be in another constant define files
const sizeRowOuter = 12; // It depends of the other variables, it should be changed depending on the borders and general size of the row.
const heighOuterDflt = 12; // Default height outer element
const widthOuterDflt = 12; // Default width outer element
const colNumOuterLayout = 1;
const heighInnerDflt = 12; // Default height outer element
const widthInnerDflt = 8; // Default width outer element
const colNumInnerLayout = 2;

//Types Cards
const TYPE_TABLE = 'table';

const nonAutomaticHeightElem = [TYPE_TABLE];

const tagOrigValuesTable = '_orig';

// Grid Constants
const COLWIDTH_GRID = 30;
const ROW_HEIGHT_GRID = 30;
const MARGIN_GRID = 10;
const NUM_COLS_GRID = 16;

const zoneNotify = 'ReportBoard';

export default {
    name: 'ReportBoard',
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        Plotly,
        RadialProgressBar,
    },
    data() {
        return {
            cardsLayout: [],
            configuration: {},
            COLWIDTH_GRID,
            ROW_HEIGHT_GRID,
            MARGIN_GRID,
            NUM_COLS_GRID,
            completedSteps: 2,
            totalSteps: 10,
            loadingKey: 0,
            isPlotlyHovered: false,
            TYPE_TABLE,
            TYPE_PLOTLY,
            forceUpdateBackEnd: false,
      isRelayoutInProcess:false,
            elementsLayout: {},
            TYPE_IMAGE: DATA_TYPE_PICTURE,
        };
    },

    computed: {
        ...mapGetters([
            'isEditModeReportViewer',
            'getForceUpdateReportViewer',
            'getCurrentReportViewer',
            'isVisibleStateReportViewer',
            'isLoadingGraphsReportViewer',
            'isExportingReportViewer',
        ]),
    },
    watch: {
        async getForceUpdateReportViewer(newValue) {
            await this.updateGraphsVuex(newValue);
        },
    },
    created() {
        this.loadGraphs();
    },
    mounted() {
        this.updateGraphsVuex(this.getForceUpdateReportViewer);
        this._resizeTimer = null;
        this._resizeObserver = new ResizeObserver(() => {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => this.onContainerResize(), 150);
        });
        this._resizeObserver.observe(this.$refs.base_report_board);
    },
    beforeDestroy() { // eslint-disable-line vue/no-deprecated-destroyed-lifecycle
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
        clearTimeout(this._resizeTimer);
    },
    methods: {
        ...mapActions([
            'setForceUpdateReportViewer',
            'setMessageTextReportViewer',
            'setMessageVisibleReportViewer',
            'setReportModifiedReportViewer',
            'setSaveLayoutReportViewer',
            'setContextOnHover',
            'setLoadingGraphsReportViewer',
            'resetConfigReportModifiedReportViewer',
            'setExportingReportViewer',
        ]),
        onHover(route) {
            this.setContextOnHover(route);
        },
        onLeave() {
            this.setContextOnHover(null);
        },
        customSorting(a, b, key) {
            const customKey = key + tagOrigValuesTable;
            return a[customKey] < b[customKey]
                ? -1
                : a[customKey] > b[customKey]
                    ? 1
                    : 0;
        },
        async updateGraphsVuex(newValue) {
            // Auxiliar function to refresh graphs when there is a change on the graphs
            if (newValue !== 0) {
                if (newValue === 1) {
                    this.forceUpdateBackEnd = true;
                }
                await this.loadGraphs();
            }
        },
        onContainerResize() {
            if (this.isLoadingGraphsReportViewer) return;
            const keys = Object.keys(this.elementsLayout);
            for (let j = 0; j < keys.length; j++) {
                const item = this.elementsLayout[keys[j]];
                if (item.type !== TYPE_PLOTLY) continue;
                const newWidth = this.units2widthPlotly(item.w);
                if (newWidth !== item.layout.width) {
                    this.$refs[keys[j]][0].relayout({ width: newWidth });
                    item.layout.width = newWidth;
                }
            }
        },
        layoutUpdatedEvent(newLayout) {
            // Trigered on change of small card size
            if (this.isLoadingGraphsReportViewer || this.isRelayoutInProcess)
                return;
            this.isRelayoutInProcess = true; // This could trigger multiple relayout, we only process one
            try{
                this.setReportModifiedReportViewer(); //Set the report as modified
                this.setSaveLayoutReportViewer(true); //Set the flag to save the layout
                let maxY = 0;
                for (let j = 0; j < newLayout.length; j++) {
                    const localMaxY = newLayout[j].h + newLayout[j].y;
                    if (localMaxY > maxY)
                        maxY = localMaxY;
                    if (newLayout[j].type === TYPE_PLOTLY){
                        const heightPlotly = this.units2heigthPlotly(newLayout[j].h);
                        if(heightPlotly !== newLayout[j].layout.height) {
                            this.$refs[newLayout[j].i][0].relayout({height: heightPlotly});
                            newLayout[j].layout.height = heightPlotly
                        }
                        const widthPlotly = this.units2widthPlotly(newLayout[j].w);
                        if(widthPlotly !== newLayout[j].layout.width) {
                            this.$refs[newLayout[j].i][0].relayout({width: widthPlotly});
                            newLayout[j].layout.width = widthPlotly
                        }
                    }
                }
                maxY += 2;
                if (newLayout.length > 0 && newLayout[0].parent.h !== maxY)
                    this.autosizeLargeCards(); //If it is different change the height and move the other cards
            }catch(error){
                const errTitle = 'Error on resize'
                const errText = 'Error while executing relayout on the grid'
                this.$notifTerm.addNotification(
                this.$notifTerm.typesNotif.ERROR,
                errTitle,
                errText,
                zoneNotify,
                );
            } finally{
                this.isRelayoutInProcess = false;
            }
        },
        layoutLargeUpdatedEvent() {
            // triggered when size change for large card
            if (this.isLoadingGraphsReportViewer || this.cardsLayout.length === 0)
                return;
            this.setSaveLayoutReportViewer(true); //Set the flag to save the layout
            this.setReportModifiedReportViewer(); //Set the report as modified
        },
        async setExportable() {
            // Modify the elements to prepare for export
            this.setExportingReportViewer(true);
            for (let j = 0; j < this.cardsLayout.length; j++) {
                for (let k = 0; k < this.cardsLayout[j].inner.length; k++) {
                    if (this.cardsLayout[j].inner[k].type === TYPE_TABLE) {
                        for (let f = 0;f < this.cardsLayout[j].inner[k].fields.length;f++) {
                            this.cardsLayout[j].inner[k].fields[f].sortable = false;
                        }
                    }
                }
            }
        },
        getHeightMM(div_element, imgWidthMM) {
            const widthPX = div_element.clientWidth;
            const heightPX = div_element.clientHeight;
            const convertedHeightMM = (heightPX * imgWidthMM) / widthPX;
            return convertedHeightMM;
        },
        async getExportableElements(imgWidthMM) {
            const exportableElements = [];
            for (let largeCard of this.cardsLayout) {
                const largeCardCmp = this.$refs[largeCard.i + '_div'][0];
                const element = await domtoimage.toPng(largeCardCmp);
                const height = this.getHeightMM(largeCardCmp, imgWidthMM);
                exportableElements.push({
                    element,
                    height,
                });
            }
            return exportableElements;
        },
        resetExportable() {
            // Restore the modifications done for export
            for (let j = 0; j < this.cardsLayout.length; j++) {
                for (let k = 0; k < this.cardsLayout[j].inner.length; k++) {
                    if (this.cardsLayout[j].inner[k].type === TYPE_TABLE) {
                        if (this.cardsLayout[j].inner[k].items < 2) {
                            //The table does not sort if it has less than 2 elements
                            continue;
                        }
                        for (let f = 0; f < this.cardsLayout[j].inner[k].fields.length; f++) {
                            this.cardsLayout[j].inner[k].fields[f].sortable = true;
                        }
                    }
                }
            }
            this.setExportingReportViewer(false);
        },
        //Auxiliar functions to translate value from pixels to grid
        units2heigthPlotly: function (unitsHeigth) {
            return ((ROW_HEIGHT_GRID + MARGIN_GRID) * unitsHeigth )- MARGIN_GRID - this.convertRemToPixels(1) - 2;
        },
        heightPlotly2units(unitsHeigth) {
            return (unitsHeigth + 2 + MARGIN_GRID) / (ROW_HEIGHT_GRID + MARGIN_GRID);
        },
        units2widthPlotly: function (unitsWidth) {
            const fullWidth = Math.round(this.$refs.base_report_board.offsetWidth * (unitsWidth / NUM_COLS_GRID))
            return fullWidth - (2 * MARGIN_GRID) - this.convertRemToPixels(2.5) - 8;
        },
        hasDuplicates(array) {
            return new Set(array).size !== array.length;
        },
        convertRemToPixels(rem) {
            return rem * parseFloat(getComputedStyle(this.$refs.base_report_board).fontSize);
        },
        setOrDefine(objectModif, key, value){
            if (key in objectModif) {
                objectModif[key] = value;
            } else {
                this.$set(objectModif, key, value);
            }
        },
        async loadGraphs() {
            //If it is already loading doesn't send the instruction again
            if (this.isLoadingGraphsReportViewer || (!this.getCurrentReportViewer.isReady && !this.forceUpdateBackEnd))
                return;
            this.setLoadingGraphsReportViewer(true);
            this.cardsLayout = [];
            this.elementsLayout = {};
            let countOuterCol = 0;
            let countOuterRow = 0;
            let countLgCrd = -1;
            this.completedSteps = 0;
            this.loadingKey = 0;

			try {
				//Request the cards from the report
				const { cardsReport, orderCards } = await ReportInfo.getReportCards(this, this.getCurrentReportViewer);
				this.resetConfigReportModifiedReportViewer();
				this.forceUpdateBackEnd = false;
				if (cardsReport === null)
					return;
				if (this.hasDuplicates(orderCards)) {
					const errTitle = 'Repeated Study';
					const errText =
						'The report has a repeated study, this is not valid. Please check the configuration or contact your system administrator';
					this.$notifTerm.addNotification(
						this.$notifTerm.typesNotif.ERROR,
						errTitle,
						errText,
						zoneNotify,
					);
					return;
				}
				const hidenElementsValid = typeof this.getCurrentReportViewer.viewConfiguration !=='undefined'
                    && typeof this.getCurrentReportViewer.viewConfiguration.hidenElements !== 'undefined';
				for (let f = 0; f < orderCards.length; f++) {
					// Cretae the large item, the container that would represent a different type of plot.
					const innercardsObjects = cardsReport[orderCards[f]];
					const typeCard = orderCards[f];
					// Verifies if it should not add this card
					if (hidenElementsValid
						&& typeof this.getCurrentReportViewer.viewConfiguration.hidenElements.groupCard !== 'undefined'
						&& typeof this.getCurrentReportViewer.viewConfiguration.hidenElements.groupCard[typeCard] !== 'undefined'
					) {
						continue;
					}
					this.cardsLayout.push({});
					countLgCrd++;
					this.$set(this.cardsLayout[countLgCrd], 'i', `${f.toString()}__${typeCard}`); // Unique Id
					this.$set(this.cardsLayout[countLgCrd], 'x', widthOuterDflt * countOuterCol); // Initial X-position
					this.$set(this.cardsLayout[countLgCrd], 'y', heighOuterDflt * countOuterRow); // Initial Y-position
					this.$set(this.cardsLayout[countLgCrd], 'w', widthOuterDflt); // Initial width
					this.$set(this.cardsLayout[countLgCrd], 'h', heighOuterDflt); // Initial height
					this.$set(this.cardsLayout[countLgCrd], 'legend', orderCards[f]);
					this.$set(this.cardsLayout[countLgCrd], 'inner', []);
					let countInnerCol = 0;
					let countInnerRow = 0;
					let countInnerCrd = -1;
					this.elementsLayout[typeCard] = this.cardsLayout[countLgCrd];
					const innercards = Object.keys(innercardsObjects);
					for (let k = 0; k < innercards.length; k++) {
						const plotId = `${typeCard}__${innercards[k]}`;
						// Verifies if it should not add this card
						if (hidenElementsValid &&
							typeof this.getCurrentReportViewer.viewConfiguration.hidenElements.smallCard !== 'undefined' &&
							typeof this.getCurrentReportViewer.viewConfiguration.hidenElements.smallCard[plotId] !== 'undefined'
						){
							continue;
						}
						if (countInnerCol === colNumInnerLayout) {
							countInnerRow++;
							countInnerCol = 0;
						}
						countInnerCrd++;
						this.cardsLayout[countLgCrd].inner.push({});
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'i', plotId); // Unique Id
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'x', widthInnerDflt * countInnerCol); // Initial X-position
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'y', heighInnerDflt * countInnerRow); // Initial Y-position
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'w', widthInnerDflt); // Initial width
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'h', heighInnerDflt); // Initial height
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'legend', innercards[k]);
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'type', innercardsObjects[innercards[k]].type);
						this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'parent', this.cardsLayout[countLgCrd]);
						this.elementsLayout[plotId] = this.cardsLayout[countLgCrd].inner[countInnerCrd];

                        if (innercardsObjects[innercards[k]].type ===TYPE_PLOTLY) {
                            this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'data', innercardsObjects[innercards[k]].data);
                            this.$set(this.cardsLayout[countLgCrd].inner[countInnerCrd], 'layout', innercardsObjects[innercards[k]].layout);
                            const heightPlotly = this.units2heigthPlotly(heighInnerDflt);
                            const widthPlotly = this.units2widthPlotly(widthInnerDflt);
                            this.setOrDefine(this.cardsLayout[countLgCrd].inner[countInnerCrd].layout, 'height', heightPlotly)
                            this.setOrDefine(this.cardsLayout[countLgCrd].inner[countInnerCrd].layout, 'width', widthPlotly)
                            this.setOrDefine(this.cardsLayout[countLgCrd].inner[countInnerCrd].layout, 'autosize', false)
                        } else if (innercardsObjects[innercards[k]].type === TYPE_TABLE) {
                            const dataTable = JSON.parse(JSON.stringify(innercardsObjects[innercards[k]].dataTable));
                            if (dataTable.length == 0) {
                                const errTitle = `Table '${plotId}' not created`;
                                const errText = `The table '${plotId}' was empty, it was removed`;
                                this.$notifTerm.addNotification(
                                    this.$notifTerm.typesNotif.ERROR,
                                    errTitle,
                                    errText,
                                    zoneNotify,
                                );
                                this.cardsLayout[countLgCrd].inner.splice(countInnerCrd, 1);
                                countInnerCrd--;
                                continue;
                            }
                            const fields = [];
                            const rowHeader = innercardsObjects[innercards[k]].headerOrder;
                            rowHeader.forEach((field) => fields.push({key: field, sortable: dataTable.length > 1,}));
                            for (let n = 0; n < dataTable.length; n++) {
                                Object.keys(dataTable[n]).forEach(function (key) {
                                    if (key.endsWith(tagOrigValuesTable)) {
                                        return;
                                    }
                                    dataTable[n][key + tagOrigValuesTable] = dataTable[n][key];
                                    if (!isNaN(dataTable[n][key])) {
                                        const absValue = Math.abs(dataTable[n][key]);
                                        if (absValue >= 10000 || (absValue < 0.01 && absValue !== 0)) {
                                            dataTable[n][key] = dataTable[n][key].toExponential(3).replace(/e\+?/, ' x 10^');
                                        } else {
                                            dataTable[n][key] = Math.round(dataTable[n][key] * 1000) / 1000;
                                        }
                                    }
                                });
                            }
                            this.$set(
                                this.cardsLayout[countLgCrd].inner[countInnerCrd],
                                'items',
                                dataTable,
                            );
                            this.$set(
                                this.cardsLayout[countLgCrd].inner[countInnerCrd],
                                'fields',
                                fields,
                            );
                        } else if ( innercardsObjects[innercards[k]].type === this.TYPE_IMAGE) {
                            this.$set(
                                this.cardsLayout[countLgCrd].inner[countInnerCrd],
                                'data',
                                innercardsObjects[innercards[k]].data,
                            );
                        }
                        this.cardsLayout[countLgCrd].inner[countInnerCrd].success = true// plotId !== 'Statistics for Fit ΔY - Amperometry Discrete (AD)__BATCH_HIST';

                        countInnerCol++;
                        this.completedSteps++;
                        this.loadingKey += 1; //Trick to update the Loading effect
                    }
                    countInnerRow++;
                    const heigthOuter = sizeRowOuter * countInnerRow + 2;
                    this.cardsLayout[countLgCrd].h = heigthOuter;

                    countOuterCol++;
                    if (countOuterCol === colNumOuterLayout) {
                        countOuterRow++;
                        countOuterCol = 0;
                    }
                }

                //Load the pictures of the report
                this.loadMediaCard({countLgCrd, countOuterCol, countOuterRow});

                //Organise the elements
                await this.$nextTick();
                await this.organizeCardsElements();
                this.$emit('cardsReloaded')
            } catch (error) {
                const errTitle = 'Cannot create the plots';
                const errText = `The configuration is not allowed. Internal Error: ${error}`;
                this.$notifTerm.addNotification(
                    this.$notifTerm.typesNotif.ERROR,
                    errTitle,
                    errText,
                    zoneNotify,
                );
            } finally {
                this.setLoadingGraphsReportViewer(false);
                this.setForceUpdateReportViewer(0);
            }
        },
        async organizeCardsElements() {
            this.autosizeCards();
            await this.$nextTick();
            await this.$nextTick();
            await this.$nextTick();
            await this.loadLayout();
            // Resize large card
            await this.$nextTick();
            await this.$nextTick();
            await this.$nextTick();
            //Requires doble tick, becuase the cards reordering
            this.autosizeLargeCards();
        },
        loadMediaCard(counters) {
            if (typeof this.getCurrentReportViewer.files === 'undefined') {
                return;
            }
            const picturesFiles = this.getCurrentReportViewer.files.filter(
                (f) => f.dataType === DATA_TYPE_PICTURE,
            );
            if (picturesFiles.length > 0) {
                this.addLargeCardPersonalized('Media', picturesFiles, counters);
            }
            const plotlyFiles = this.getCurrentReportViewer.files.filter(
                (f) => f.dataType === DATA_TYPE_PLOTLY,
            );
            if (plotlyFiles.length > 0) {
                this.addLargeCardPersonalized(
                    'Imported Plotly',
                    plotlyFiles,
                    counters,
                );
            }
        },
        addLargeCardPersonalized(typeCard, elements, counters) {
            const hidenElementsValid = typeof this.getCurrentReportViewer.viewConfiguration !=='undefined'
                                       && typeof this.getCurrentReportViewer.viewConfiguration.hidenElements !== 'undefined';

			// Check if the user removed the Media card
			if (hidenElementsValid
				&& typeof this.getCurrentReportViewer.viewConfiguration.hidenElements.groupCard !== 'undefined'
				&& typeof this.getCurrentReportViewer.viewConfiguration.hidenElements.groupCard[typeCard] !== 'undefined'
			) {
				return;
			}
			this.cardsLayout.push({});
			counters.countLgCrd++;
			this.$set(this.cardsLayout[counters.countLgCrd], 'i', `0__${typeCard}`); // Unique Id
			this.$set(this.cardsLayout[counters.countLgCrd], 'x', widthOuterDflt * counters.countOuterCol); // Initial X-position
			this.$set(this.cardsLayout[counters.countLgCrd], 'y', heighOuterDflt * counters.countOuterRow); // Initial Y-position
			this.$set(this.cardsLayout[counters.countLgCrd], 'w', widthOuterDflt); // Initial width
			this.$set(this.cardsLayout[counters.countLgCrd], 'h', heighOuterDflt); // Initial height
			this.$set(this.cardsLayout[counters.countLgCrd], 'legend', typeCard);
			this.$set(this.cardsLayout[counters.countLgCrd], 'inner', []);
			let countInnerCol = 0;
			let countInnerRow = 0;
			let countInnerCrd = -1;
			this.elementsLayout[typeCard] =
				this.cardsLayout[counters.countLgCrd];
			for (let n = 0; n < elements.length; n++) {
				const fileName = elements[n].name.replace(/\.[^/.]+$/, '');
				const plotId = `${typeCard}__${elements[n].name}`;
				// Verifies if it should not add this card
				if (
					hidenElementsValid &&
					typeof this.getCurrentReportViewer.viewConfiguration
						.hidenElements.smallCard !== 'undefined' &&
					typeof this.getCurrentReportViewer.viewConfiguration
						.hidenElements.smallCard[plotId] !== 'undefined'
				) {
					continue;
				}
				if (countInnerCol === colNumInnerLayout) {
					countInnerRow++;
					countInnerCol = 0;
				}
				this.cardsLayout[counters.countLgCrd].inner.push({});
				countInnerCrd++;
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'i', plotId); // Unique Id
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'x', widthInnerDflt * countInnerCol); // Initial X-position
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'y', heighInnerDflt * countInnerRow); // Initial Y-position
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'w', widthInnerDflt); // Initial width
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'h', heighInnerDflt); // Initial height
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'legend', fileName);
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'hover', false);
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'type', elements[n].dataType);
				this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'parent', this.cardsLayout[counters.countLgCrd]);

                this.cardsLayout[counters.countLgCrd].inner[countInnerCrd].success = true;
                this.elementsLayout[plotId] = this.cardsLayout[counters.countLgCrd].inner[countInnerCrd];
                if (elements[n].dataType === DATA_TYPE_PLOTLY) {
                    //Verify imported Plotly graph
                    if (typeof elements[n].extractedData.layout.width !=='undefined') {
                        delete elements[n].extractedData.layout.width;
                    }
                    elements[n].extractedData.layout.margin = { l: 0, r: 0 };
                    this.formatAxisImportedPlotly(elements[n].extractedData.layout.xaxis);
                    this.formatAxisImportedPlotly(elements[n].extractedData.layout.yaxis);
                    let counter = 2;
                    while (this.formatAxisImportedPlotly(elements[n].extractedData.layout[`yaxis${counter}`])) {
                        counter++;
                    }
                    //Trick for the legend position
                    if (counter > 3) {
                        const positionX = 1 + 0.025 * (counter - 2);
                        elements[n].extractedData.layout.legend = {
                            x: positionX,
                        };
                    }
                    this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'data', elements[n].extractedData.data,);
                    this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'layout', elements[n].extractedData.layout,);
                    const heightPlotly = this.units2heigthPlotly(heighInnerDflt);
                    const widthPlotly = this.units2widthPlotly(widthInnerDflt);
                    this.setOrDefine(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd].layout, 'height', heightPlotly)
                    this.setOrDefine(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd].layout, 'width', widthPlotly)
                    this.setOrDefine(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd].layout, 'autosize', false)
                } else {
                    this.$set(this.cardsLayout[counters.countLgCrd].inner[countInnerCrd], 'data', elements[n].extractedData);
                }
                countInnerCol++;
            }
            countInnerRow++;
            const heigthOuter = sizeRowOuter * countInnerRow + 2;
            this.cardsLayout[counters.countLgCrd].h = heigthOuter;

            counters.countOuterCol++;
            if (counters.countOuterCol === colNumOuterLayout) {
                counters.countOuterRow++;
                counters.countOuterCol = 0;
            }
        },
        formatAxisImportedPlotly(axis) {
            if (typeof axis !== 'undefined') {
                if (
                    typeof axis.title !== 'undefined' &&
                    typeof axis.title.font !== 'undefined' &&
                    typeof axis.title.font.size !== 'undefined'
                ) {
                    delete axis.title.font.size;
                }
                axis.automargin = true;
                return true;
            }
            return false;
        },
        //Resize the cards depending the inner value and resize the main large containers
        autosizeCards() {
            const cardsToResize = [];
            for (let f = 0; f < this.cardsLayout.length; f++) {
                const largeCardObj = this.cardsLayout[f];
                for (let n = 0; n < largeCardObj.inner.length; n++) {
                    cardsToResize.push(largeCardObj.inner[n]);
                }
            }
            this.autosizeSmallCards(cardsToResize);
        },
        autosizeSmallCards(cardsToResize) {
            for (let n = 0; n < cardsToResize.length; n++) {
                const innerCardObj = cardsToResize[n];
                if (nonAutomaticHeightElem.includes(innerCardObj.type)) {
                    if (typeof this.$refs['div_' + innerCardObj.i] === 'undefined') {
                        continue;
                    }
                    const constructedElem = this.$refs['div_' + innerCardObj.i][0];
                    const newHeight = this.heightPlotly2units(constructedElem.clientHeight);
                    this.$set(innerCardObj, 'h', newHeight);
                }
            }
        },
        autosizeLargeCards() {
            for (let f = 0; f < this.cardsLayout.length; f++) {
                const largeCardObj = this.cardsLayout[f];
                let maxY = 0;
                // First update the layout to apply any change
                if (typeof this.$refs[largeCardObj.i + '_layout'] === 'undefined') {
                    continue;
                }
                const layout_item = this.$refs[largeCardObj.i + '_layout'][0];
                layout_item.layoutUpdate();
                for (let n = 0; n < largeCardObj.inner.length; n++) {
                    const innerCardObj = largeCardObj.inner[n];
                    const innerMaxY = innerCardObj.h + innerCardObj.y;
                    if (innerMaxY > maxY) {
                        maxY = innerMaxY;
                    }
                }
                this.$set(largeCardObj, 'h', maxY + 2);
            }
            this.$refs.board_grid.layoutUpdate();
        },
        async loadLayout() {
            const layoutReport = this.getCurrentReportViewer.layout;
            //Verify the Consistency of the layout
            const keysCurrentLayout = Object.keys(this.elementsLayout);
            const cardsToAutosize = [];
            for (let j = 0; j < keysCurrentLayout.length; j++) {
                let layoutElement = {};
                if (typeof layoutReport !== 'undefined' && keysCurrentLayout[j] in layoutReport) {
                    layoutElement = layoutReport[keysCurrentLayout[j]];
                } else {
                    this.setSaveLayoutReportViewer(true);
                    if (!(keysCurrentLayout[j] in defaultLayoutGraphs))
                        continue;
                    layoutElement = defaultLayoutGraphs[keysCurrentLayout[j]];
                }
                this.$set(this.elementsLayout[keysCurrentLayout[j]], 'x', layoutElement.x,);
                this.$set(this.elementsLayout[keysCurrentLayout[j]], 'y', layoutElement.y,);
                this.$set(this.elementsLayout[keysCurrentLayout[j]], 'w', layoutElement.w,);
                if (typeof layoutElement.h !== 'undefined') {
                    this.$set(this.elementsLayout[keysCurrentLayout[j]], 'h', layoutElement.h);
                } else if (this.elementsLayout[keysCurrentLayout[j]].type === TYPE_TABLE) {
                    // If not defined and it is table then it would need to calculate after the rendering
                    cardsToAutosize.push(this.elementsLayout[keysCurrentLayout[j]]);
                }
                if (this.elementsLayout[keysCurrentLayout[j]].type === TYPE_PLOTLY){
                    const heightPlotly = this.units2heigthPlotly(layoutElement.h);
                    if(heightPlotly !== this.elementsLayout[keysCurrentLayout[j]].layout.height) {
                        this.$refs[keysCurrentLayout[j]][0].relayout({height: heightPlotly});
                        this.elementsLayout[keysCurrentLayout[j]].layout.height = heightPlotly
                    }
                    const widthPlotly = this.units2widthPlotly(layoutElement.w);
                    if(widthPlotly !== this.elementsLayout[keysCurrentLayout[j]].layout.width) {
                        this.$refs[keysCurrentLayout[j]][0].relayout({width: widthPlotly});
                        this.elementsLayout[keysCurrentLayout[j]].layout.width = widthPlotly
                    }
                }
            }
            if (cardsToAutosize.length > 0) {
                await this.$nextTick();
                await this.$nextTick();
                await this.$nextTick();
                //At the end autosize the cards that were not defined
                this.autosizeSmallCards(cardsToAutosize);
            }
            return true;
        },
        saveLayout() {
            const newLayout = {};
            const keysCurrentLayout = Object.keys(this.elementsLayout);
            for (let j = 0; j < keysCurrentLayout.length; j++) {
                newLayout[keysCurrentLayout[j]] = {
                    x: this.elementsLayout[keysCurrentLayout[j]].x,
                    y: this.elementsLayout[keysCurrentLayout[j]].y,
                    w: this.elementsLayout[keysCurrentLayout[j]].w,
                    h: this.elementsLayout[keysCurrentLayout[j]].h,
                };
            }
            this.getCurrentReportViewer.layout = newLayout;
        },
        hideCard(item) {
            this.setReportModifiedReportViewer();
            if (
                typeof this.getCurrentReportViewer.viewConfiguration ===
                'undefined'
            ) {
                this.getCurrentReportViewer.viewConfiguration = {};
            }
            if (
                typeof this.getCurrentReportViewer.viewConfiguration
                    .hidenElements === 'undefined'
            ) {
                this.getCurrentReportViewer.viewConfiguration.hidenElements =
                    {};
            }
            if (typeof item.parent !== 'undefined') {
                //It means it is a leaf
                if (
                    typeof this.getCurrentReportViewer.viewConfiguration
                        .hidenElements.smallCard === 'undefined'
                ) {
                    this.getCurrentReportViewer.viewConfiguration.hidenElements.smallCard =
                        {};
                }
                this.getCurrentReportViewer.viewConfiguration.hidenElements.smallCard[
                    item.i
                ] = true;
                const index_parent_arr = item.parent.inner.findIndex(
                    (card) => card.i === item.i,
                );
                item.parent.inner.splice(index_parent_arr, 1);
            } else {
                // It is a card container
                if (
                    typeof this.getCurrentReportViewer.viewConfiguration
                        .hidenElements.groupCard === 'undefined'
                ) {
                    this.getCurrentReportViewer.viewConfiguration.hidenElements.groupCard =
                        {};
                }
                const index_split = item.i.split('__');
                this.getCurrentReportViewer.viewConfiguration.hidenElements.groupCard[
                    index_split[1]
                ] = true;
                const index_elements_arr = this.cardsLayout.findIndex(
                    (card) => card.i === item.i,
                );
                this.cardsLayout.splice(index_elements_arr, 1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.vue-grid-item {
    border-style: solid;
    border-color: #fff;
}

.grid-item-largeCard {
    background: #fff;
    border: 1px solid black;
    border-radius: 10px;
}

.grid-item-smallCard {
    background: #fff;
    border: 1px solid #ebebeb;
}

.vue-grid-layout {
    background: #fff;
}

::v-deep .vue-grid-layout {
    border-radius: 10px 10px 0px 0px;
}

.largeCard {
    background: #ebebeb;
    border-radius: 10px;
    box-shadow: 5px 5px 10px 2px #ccc;
    height: auto;
}

.vue-grid-item.resizing {
    opacity: 0.9;
}

.vue-grid-item.static {
    background-color: #cce;
}

p.plotly-title {
    margin: 0;
    text-align: center;
    color: #fff;
}

div.loading {
    position: fixed;
    top: 3rem;
    left: 0px;
    height: 100%;
    width: 100%;
}

div.loading-elements {
    text-align: center;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

div.main-container-report.disabled {
    opacity: 0.5;
}

div.main-container-report {
    background-color: #ebebeb;
    border-radius: 10px;
}

div.plotly-title-container {
    background-color: #5b5b5b;
    border-radius: 10px 10px 0px 0px;
}

.errorRendering {
    width: 100%;
    max-width: 100%;
    height: 90%;
    border-radius: 5px;
}

.error-text-card {
    margin: 0;
}

.table-card {
    font-size: 0.8rem;
    overflow: hidden !important;
}

.more-options-card {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1000;
}

.more-options-card-plotly {
    left: 0;
    right: auto;
}

.btn-more-options {
    font-weight: bolder;
    font-size: 1.25rem;
}

.file-name {
    font-weight: bold;
    color: white;
}

.file-name-div {
    text-align: center;
    background-color: black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.picture-card {
    height: calc(100% - 2.5rem);
    height: -o-calc(100% - 2.5rem);
    /* opera */
    height: -webkit-calc(100% - 2.5rem);
    /* google, safari */
    height: -moz-calc(100% - 2.5rem);
    /* firefox */
}

.js-plotly-plot .plotly .modebar-group {
    float: left;
    box-sizing: border-box;
    padding-left: 8px;
    position: relative;
    vertical-align: middle;
    display: flex !important;
    flex-direction: row !important;
    white-space: nowrap;
}

.table-div {
    max-height: 100%;
    overflow-y: auto;
}
</style>